/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, OPTMAKE){
	const a = 'is-active';
	const v = 'is-visible';
	const $map = location.pathname;

	const repairMenu = () => {

		$('.idx-repair-ul-li-a').each((idx, ele) => {
			if($map === $(ele).attr('href') || $map === $(ele).attr('href') + 'index.html') {
				$(ele).addClass('is-current');
			}
		});
	};

	if($('.inc_common_repair').length) {
		repairMenu();
	}

})(window.jQuery, window.OPTMAKE);
